export default "__VITE_ASSET__73445c98__"